import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: string[];
  fallbackPath?: string;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ 
  children, 
  allowedRoles, 
  fallbackPath 
}) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '1.2rem'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const userRole = user.role;
  
  // Admin can access everything
  if (userRole === 'admin') {
    return <>{children}</>;
  }

  // Check if user's role is in allowed roles
  if (!allowedRoles.includes(userRole)) {
    // Redirect to appropriate dashboard based on user's role
    const redirectPath = fallbackPath || getDefaultPathForRole(userRole);
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

// Helper function to get default path for each role
const getDefaultPathForRole = (role: string): string => {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'manager':
      return '/manager';
    case 'merchant':
      return '/merchant';
    default:
      return '/login';
  }
};

export default RoleGuard;













